module.exports = __webpack_public_path__ + "img/camp02_open.f9597f63.png";